export const GATEWAY_DOCS_URL = "https://langfuse.com/docs/ai-gateway";

export const GATEWAY_SETUP_DOCS_URL = `${GATEWAY_DOCS_URL}/get-started/admin-setup`;
export const GATEWAY_FIRST_REQUEST_DOCS_URL = `${GATEWAY_DOCS_URL}/get-started/first-request`;
export const GATEWAY_MODELS_DOCS_URL = `${GATEWAY_DOCS_URL}/features/models`;
export const GATEWAY_API_KEYS_DOCS_URL = `${GATEWAY_DOCS_URL}/features/api-keys`;
export const GATEWAY_ANALYTICS_DOCS_URL = `${GATEWAY_DOCS_URL}/features/analytics`;
export const GATEWAY_CODING_AGENTS_DOCS_URL = `${GATEWAY_DOCS_URL}/coding-agents`;

export const GATEWAY_SELF_HOSTING_DOCS_URL =
  "https://langfuse.com/self-hosting/configuration/ai-gateway";
